import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { injectCountryList } from '@recruitee/country-data';
import type { Country } from '@recruitee/locations-types';
import { SelectComponent, SelectOption } from '@recruitee/user-interface';

import { Destroyable } from '../../../common';
import { DynamicCountrySelectInputConfig } from '../../types';
import { DynamicFormInput } from '../dynamic-form/dynamic-form-input/dynamic-form-input';

export class CountrySelectInput extends DynamicFormInput<DynamicCountrySelectInputConfig> {}

@Component({
  selector: 'rti-country-select-input',
  templateUrl: './country-select-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, SelectComponent],
})
@Destroyable()
export class CountrySelectInputComponent {
  @Input() public input: CountrySelectInput;

  public countryOptions: Array<SelectOption<string>> = injectCountryList().map(
    (country: Country) => ({ label: country.name, value: country.code }),
  );
}
